import React from "react";
import { AlertCircle, Inbox } from "lucide-react";

export function Spinner({ label = "Loading..." }) {
  return (
    <div className="flex items-center justify-center gap-2 text-sm text-muted-foreground">
      <span className="h-4 w-4 rounded-full border-2 border-primary/25 border-t-primary animate-spin" />
      {label}
    </div>
  );
}

export function EmptyState({ title, message, icon }) {
  return (
    <div className="border border-dashed border-border rounded-xl bg-white py-10 px-5 text-center text-muted-foreground">
      <div className="mx-auto mb-3 flex h-10 w-10 items-center justify-center rounded-full bg-slate-100 text-slate-500">
        {icon || <Inbox size={18} />}
      </div>
      <div className="font-semibold text-foreground">{title}</div>
      {message ? <div className="mt-1 text-sm">{message}</div> : null}
    </div>
  );
}

export function ErrorState({ message, onRetry }) {
  return (
    <div className="rounded-xl border border-destructive/20 bg-destructive/5 px-5 py-4 text-sm text-destructive">
      <div className="flex items-start gap-2">
        <AlertCircle size={18} className="mt-0.5 shrink-0" />
        <div className="flex-1">
          <div className="font-semibold">Could not load data</div>
          <div className="mt-0.5">{message || "Please try again."}</div>
        </div>
        {onRetry ? (
          <button onClick={onRetry} className="rounded-lg bg-white px-3 py-1.5 font-semibold text-foreground hover:bg-secondary">
            Retry
          </button>
        ) : null}
      </div>
    </div>
  );
}

export function CardSkeleton({ rows = 3 }) {
  return (
    <div className="space-y-3">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="card-soft p-4 animate-pulse">
          <div className="h-4 w-2/5 rounded bg-primary/10" />
          <div className="mt-3 h-3 w-3/5 rounded bg-slate-100" />
        </div>
      ))}
    </div>
  );
}

export function TableSkeleton({ rows = 5, columns = 4 }) {
  return (
    <>
      {Array.from({ length: rows }).map((_, r) => (
        <tr key={r} className="border-t border-border/60 animate-pulse">
          {Array.from({ length: columns }).map((__, c) => (
            <td key={c} className="px-5 py-4">
              <div className="h-3 rounded bg-primary/10" />
            </td>
          ))}
        </tr>
      ))}
    </>
  );
}
